(function initProductDetailsTabs() {
  const TABS_ANCHOR_ID = 'product-details-tabs';
  const WRITE_REVIEW_BTN_SELECTOR = '#writeReviewBtn';
  const WRITE_REVIEW_FORM_SELECTOR = '#trustspot-write-review';

  /**
   * Activates the tab whose panel matches panelId, and deactivates all others.
   * @param {Element} tabsEl - The .product-details__tabs container.
   * @param {string} panelId - The id of the panel to activate.
   */
  function activateTab(tabsEl, panelId) {
    if (!(tabsEl instanceof Element) || !panelId) return;

    const tabButtons = tabsEl.querySelectorAll('[role="tab"]');
    const tabPanels = tabsEl.querySelectorAll('[role="tabpanel"]');
    const button = tabsEl.querySelector(`[aria-controls="${panelId}"]`);
    const panel = tabsEl.querySelector(`#${panelId}`);

    if (!(button instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    tabButtons.forEach((tab) => {
      if (!(tab instanceof HTMLButtonElement)) return;

      tab.setAttribute('aria-selected', 'false');
      tab.tabIndex = -1;
      tab.classList.remove('is-active');
    });

    tabPanels.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;

      item.hidden = true;
      item.classList.remove('is-active');
    });

    button.setAttribute('aria-selected', 'true');
    button.tabIndex = 0;
    button.classList.add('is-active');

    panel.hidden = false;
    panel.classList.add('is-active');
  }

  /**
   * Finds the Reviews tab's panel id within a given tabs container.
   * @param {Element} tabsEl
   * @returns {string|null}
   */
  function getReviewsPanelId(tabsEl) {
    if (!(tabsEl instanceof Element)) return null;

    const reviewsTab = tabsEl.querySelector('[id^="tab-reviews-"]');
    return reviewsTab ? reviewsTab.getAttribute('aria-controls') : null;
  }

  /**
   * Waits for an element matching selector to appear in the DOM (RaveCapture
   * renders its widget asynchronously), resolving null on timeout.
   * @param {string} selector
   * @param {{ timeout?: number }} [options]
   * @returns {Promise<Element|null>}
   */
  function waitForElement(selector, { timeout = 5000 } = {}) {
    return new Promise((resolve) => {
      const existing = document.querySelector(selector);
      if (existing) return resolve(existing);

      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }, timeout);
    });
  }

  document.querySelectorAll('.product-details__tabs').forEach((tabs) => {
    const tabButtons = tabs.querySelectorAll('[role="tab"]');

    tabButtons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.addEventListener('click', () => {
        const panelId = button.getAttribute('aria-controls');
        if (panelId) activateTab(tabs, panelId);
      });
    });
  });

  document.querySelectorAll('[data-reviews-tab-link]').forEach((link) => {
    link.addEventListener('click', () => {
      const tabsEl = document.getElementById(TABS_ANCHOR_ID);
      const panelId = getReviewsPanelId(tabsEl);
      if (tabsEl && panelId) activateTab(tabsEl, panelId);
    });
  });

  document.querySelectorAll('[data-write-review-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', async () => {
      const tabsEl = document.getElementById(TABS_ANCHOR_ID);
      const panelId = getReviewsPanelId(tabsEl);
      if (tabsEl && panelId) activateTab(tabsEl, panelId);

      tabsEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const nativeTrigger = await waitForElement(WRITE_REVIEW_BTN_SELECTOR);
      if (!(nativeTrigger instanceof HTMLElement)) return; // no reviews yet — RaveCapture doesn't render the button

      nativeTrigger.click();

      const formEl = await waitForElement(WRITE_REVIEW_FORM_SELECTOR);
      formEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  function syncReviewsTabWithHash() {
    if (window.location.hash !== `#${TABS_ANCHOR_ID}`) return;

    const tabsEl = document.getElementById(TABS_ANCHOR_ID);
    const panelId = getReviewsPanelId(tabsEl);
    if (tabsEl && panelId) activateTab(tabsEl, panelId);
  }

  window.addEventListener('hashchange', syncReviewsTabWithHash);
  syncReviewsTabWithHash();
})();